import React from 'react';
import IconComponent from '../icons';
import BaseButton from '../BaseButton';
import { checkActive } from '../../utils/helpers';

const Filters = (props)=> {
  const {data, pageHeading, filterHeading, viewAllText, clearFilterText, applyFilterText, handleFilters, viewAllFilters, clearAllFilters, toggleFilter, viewAllDefault, setViewAllDefault} = props;
  const searchedProducts = sessionStorage.getItem("searchedProducts") !== null ? sessionStorage.getItem("searchedProducts").split(",") : [];
  const renderFilters =()=>{
    return data && data.map((item, index)=>{
      const type = item.isActive ? "CLEAR" : "APPLY";
      return (
        <li key={`filter-item-${index}`} className={`cursor-pointer mb-5 flex items-center ${(searchedProducts.length && !searchedProducts.includes(item.title)) && !item.isActive ? "pointer-events-none opacity-30" : ""}`} onClick={()=>{handleFilters(type, item.title, !item.isActive, index);}}>
          <span><IconComponent icon={item.isActive ? 'checkbox-checked' : "checkbox"} className={`mr-2 text-ek-red`} /></span>
          <span>{item.title}</span>
        </li>
      )
    })
  }
  
  const activeList = data && data.length && data.map((item)=>{
    return item.isActive;
  });

  const renderViewAll =()=>{
    if(viewAllDefault && !activeList.some(checkActive)){
      return (
        <li className={`cursor-pointer mb-5 flex items-center text-sm font-normal text-black leading-[21px] tracking-[0.56px] ${searchedProducts.length ? "pointer-events-none opacity-30" : ""}`} onClick={()=>{setViewAllDefault(false)}}>
          <span><IconComponent icon="checkbox-checked" className={`mr-2 text-ek-red`} /></span>
          <span>{viewAllText}</span>
        </li>
      )
    }
    else{
      return (
        <li className={`cursor-pointer mb-5 flex items-center text-sm font-normal text-black leading-[21px] tracking-[0.56px] ${searchedProducts.length ? "pointer-events-none opacity-30" : ""}`} onClick={()=>{viewAllFilters(!activeList.every(checkActive));}}>
          <span><IconComponent icon={activeList.every(checkActive) ? 'checkbox-checked' : "checkbox"} className={`mr-2 text-ek-red`} /></span>
          <span>{viewAllText}</span>
        </li>
      )
    }
    
  }

  const renderClearAll =()=>{
    return (
      <div className={`text-base font-bold text-ek-red leading-6 tracking-[1.6px] text-center lg:text-left mt-[18px] lg:mt-0 ${activeList.some(checkActive) || (sessionStorage.getItem("searchedProducts") !== null && sessionStorage.getItem("searchedProducts") === "") ? "opacity-100 cursor-pointer" : "opacity-50 cursor-default pointer-events-none"}`} onClick={()=>{clearAllFilters()}}>
        <span>{clearFilterText}</span>
      </div>
    )
  }

  const renderFilterHead =()=>{
    return(
      <div className="py-5 px-4 lg:hidden relative">
            <div className="text-xs font-bold text-ek-red tracking-[4.8px] pb-2">{pageHeading}</div>
            <div className="text-[21px] font-semibold text-ek-grey-700 leading-[27px] tracking-[.42px]">{filterHeading}</div>
            <span className="absolute right-0 top-0 z-10 p-4 mt-1 mr-1" onClick={()=>{toggleFilter(false)}}><IconComponent icon="menu-close" className="w-[16px] h-[16px] text-ek-grey-500" /></span>
      </div>
    )
  }

  const applyButtonClick =()=>{
    toggleFilter(false);
  }
  
  return (
    <>
      {renderFilterHead()}
      <div className="lg:pr-5">
        <div className="text-lg font-bold text-black mb-6 leading-[27px] tracking-[.36px] hidden lg:block">{filterHeading}</div>
        <ul className="text-sm font-normal text-black leading-[21px] tracking-[0.56px] list-none overflow-y-auto lg:overflow-hidden h-[calc(100vh-246px)] lg:h-full px-4 lg:px-0">
          {renderViewAll()}
          {renderFilters()}
        </ul>
        <div className="rounded-t-lg flex justify-center flex-col p-4 lg:p-0 lg:mb-5 shadow-[0px_-3px_10px_0px_rgba(0,0,0,0.10)] lg:shadow-none">
          <BaseButton title={applyFilterText}  type="primary" size="large" className="w-full lg:hidden" btnClick={applyButtonClick}></BaseButton>
          {renderClearAll()}
        </div>
      </div>
    </>
  )
}

export default Filters;
